import { Routes, Route, Navigate } from "react-router-dom";
import { ClientLayout } from "../layouts";
import { EventDetail } from "../components/Web";
import {
  Home,
  Contact,
  Blog,
  Courses,
  Post,
  Auth,
  PrivacyPolicy,
  TermsOfService,
} from "../pages/web";

export function WebRouter() {
  const loadLayout = (Layout, Page) => {
    return (
      <Layout>
        <Page />
      </Layout>
    );
  };

  return (
    <Routes>
      <Route path="/login/*" element={loadLayout(ClientLayout, Auth)} />
      <Route path="/admin/*" element={<Navigate to="/login" replace />} />
      <Route path="/student/*" element={<Navigate to="/login" replace />} />

      {/* Original Home moved to /home */}
      <Route path="/" element={loadLayout(ClientLayout, Home)} />

      {/* Existing routes */}
      <Route path="/courses" element={loadLayout(ClientLayout, Courses)} />
      <Route path="/contact" element={loadLayout(ClientLayout, Contact)} />
      <Route path="/blog" element={loadLayout(ClientLayout, Blog)} />
      <Route path="/blog/:path" element={loadLayout(ClientLayout, Post)} />
      <Route path="/events/:slug" element={loadLayout(ClientLayout, EventDetail)} />
      <Route path="/privacy-policy" element={loadLayout(ClientLayout, PrivacyPolicy)} />
      <Route path="/terms-of-service" element={loadLayout(ClientLayout, TermsOfService)} />
    </Routes>
  );
}
